import { defineAsyncComponent } from "vue";
const FilePickerVue = defineAsyncComponent(() => import("./FilePicker-DUbP4INd.mjs"));
export {
  FilePickerVue
};
